module.exports = __webpack_public_path__ + "media/images/help/flow/eyecatch-couple-4183f18977782e56ba9277f31216d1f6.svg";